import { useContext, useState, useEffect } from 'react';

import {
  Box,
  alpha,
  Stack,
  lighten,
  Divider,
  IconButton,
  Tooltip,
  styled,
  useTheme,
  Typography, InputLabel, MenuItem, FormControl
} from '@mui/material';
import MenuTwoToneIcon from '@mui/icons-material/MenuTwoTone';
import { SidebarContext } from 'src/contexts/SidebarContext';
import CloseTwoToneIcon from '@mui/icons-material/CloseTwoTone';
import Select, { SelectChangeEvent } from '@mui/material/Select';

import HeaderButtons from './Buttons';
import HeaderUserbox from './Userbox';
import HeaderMenu from './Menu';
import { useLocation } from 'react-router-dom';
import useAxios from 'src/axios/useAxios';
import { useUserInfo } from 'src/store/user-info-context';

const HeaderWrapper = styled(Box)(
  ({ theme }) => `
        height: ${theme.header.height};
        color: ${theme.header.textColor};
        padding: ${theme.spacing(0, 2)};
        right: 0;
        z-index: 6;
        background-color: ${alpha(theme.header.background, 0.95)};
        backdrop-filter: blur(3px);
        position: fixed;
        justify-content: space-between;
        width: 100%;
        @media (min-width: ${theme.breakpoints.values.lg}px) {
            left: ${theme.sidebar.width};
            width: auto;
        }
`
);

function Header() {
  const { sidebarToggle, toggleSidebar } = useContext(SidebarContext);
  const theme = useTheme();
  const location = useLocation();
  const currentRoute = location.pathname;
  const { data, isLoading, error, sendRequest } = useAxios();
  const { user } = useUserInfo();
  const [companyLogo, setCompanyLogo] = useState<any>();

  const [programId, setProgramId] = useState<any>(1);
  const [programList, setProgramList] = useState<any>([]);

  const routeHeaderText = {
    '/': 'Dashboard',
    '/patient-details/:id': 'Patient Information',
    '/order-details/:id': 'Order Information',
    '/patients': 'Patients',
    '/orders': 'Orders',
    '/pharmacy': 'Pharmacy',
    '/add-patient': 'Add Patient',
    '/contact': 'Contact Us',
    '/doctors': 'Doctors',
    '/add-pharmacy': 'Add Pharmacy',
    '/chat': 'Chats',
    '/pharmacy/:id': 'Pharmacy',
    '/hospitals': 'Hospitals',
    '/program': 'Program',
    '/custom-fields': 'Custom Fields',
  };

  const findHeaderText = (currentPath) => {
    for (let path in routeHeaderText) {
      const pathPattern = path.replace(/:[^/]+/g, '[^/]+');
      const regex = new RegExp(`^${pathPattern}$`);
      if (regex.test(currentPath)) {
        return routeHeaderText[path];
      }
    }
    return '';
  };

  const headerText = findHeaderText(currentRoute);

  useEffect(() => {
    if(user?.company_id){
      sendRequest(`GET`, `company/get-details/${user?.company_id}`);
    }
  }, [sendRequest, user?.company_id]);

  useEffect(() => {
    if(data){
      setCompanyLogo(data.company.logo_url);
    }
  }, [data]);

  return (
    <HeaderWrapper
      display="flex"
      alignItems="center"
      sx={{
        boxShadow:
          theme.palette.mode === 'dark'
            ? `0 1px 0 ${alpha(
                lighten(theme.colors.primary.main, 0.7),
                0.15
              )}, 0px 2px 8px -3px rgba(0, 0, 0, 0.2), 0px 5px 22px -4px rgba(0, 0, 0, .1)`
            : `0px 2px 8px -3px ${alpha(
                theme.colors.alpha.black[100],
                0.2
              )}, 0px 5px 22px -4px ${alpha(
                theme.colors.alpha.black[100],
                0.1
              )}`
      }}
    >
      <Stack
        direction="row"
        divider={<Divider orientation="vertical" flexItem />}
        alignItems="center"
        spacing={2}
      >
        
        {companyLogo && (
          <div style={{ marginTop: "10px" }}>
              <img
              src={process.env.REACT_APP_BASE_URL+companyLogo}
              style={{
                  maxWidth: "100%",
                  maxHeight: "70px",
                  border: "1px solid #ddd",
                  borderRadius: "8px",
              }}
              />
          </div>
        )}

      </Stack>
      <Box display="flex" alignItems="center">
        
        {/* <Box sx={{ minWidth: 150, mr: 2 }}>
          <FormControl fullWidth size='small'>
            <Select
              
              labelId="select-program-label"
              id="select-program"
              value={programId}
              
              onChange={handleChange}
            >
              {programList.map((p) => (
                <MenuItem key={p.id} value={p.id}>{p.program_name}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box> */}
        <HeaderUserbox />
        <HeaderButtons />
        
        <Box
          component="span"
          sx={{
            ml: 2,
            display: { lg: 'none', xs: 'inline-block' }
          }}
        >
          <Tooltip arrow title="Toggle Menu">
            <IconButton color="primary" onClick={toggleSidebar}>
              {!sidebarToggle ? (
                <MenuTwoToneIcon fontSize="small" />
              ) : (
                <CloseTwoToneIcon fontSize="small" />
              )}
            </IconButton>
          </Tooltip>
        </Box>
      </Box>
    </HeaderWrapper>
  );
}

export default Header;
